/**
 * Most of our videos are vertical phone recordings, so defaulting to a vertical aspect ratio
 * reduces layout shifts.
 */
export const DEFAULT_ASPECT_RATIO = 3 / 4;
